module.exports = __webpack_public_path__ + "img/shadow_clevik.c6595617.png";